
import React from 'react';
import "./styles/Linkss.scss";




export default function Linkss() {

    
    
 
    return (
        <section className="linkss">
            
            
            <p><a href="https://twitter.com/canto_cuties">Twitter</a></p>
            <p><a href="https://discord.gg/GM4aV3DRUR">Discord</a></p>
            <p><a href="https://alto.build/collections/cantocuties">Alto</a></p>
            <p><a href="https://evm.explorer.canto.io/address/0x3eCD53103695957d4b5A3561bdd284eaccEED8D9/">Contract (evm.explorer.canto.io)</a></p>
            <p><a href="https://tuber.build/address/0x3eCD53103695957d4b5A3561bdd284eaccEED8D9/">Contract (tuber.build)</a></p>
        </section>
    ); 
}
